import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-background">
        <div className="geometric-pattern"></div>
        <div className="fan-shapes">
          <div className="fan-shape fan-1"></div>
          <div className="fan-shape fan-2"></div>
          <div className="fan-shape fan-3"></div>
        </div>
      </div>
      
      <div className="hero-content">
        <div className="art-deco-border">
          <div className="hero-text">
            <h2>SURFACE PATTERN</h2>
            <h1>DESIGN STUDIO</h1>
            <p>Where Art Deco meets contemporary pattern design</p>
            <div className="hero-ornaments">
              <span className="ornament">◆</span>
              <span className="ornament">●</span>
              <span className="ornament">▲</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="zigzag"></div>
    </section>
  );
};

export default Hero;